import {
  createSchedule,
  updateSchedule,
  getScheduleList,
  confirmTask,
} from "@/api/calendar";

const state = () => {
  return {
    schedules: [],
    loading: false,
  };
};

const mutations = {
  SET_SCHEDULES(state, schedules) {
    state.schedules = schedules;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  async fetchSchedules({ commit, rootState }) {
    commit("SET_LOADING", true);
    try {
      const userId = rootState.user.userId;
      const res = await getScheduleList(userId);
      const { code, data } = res;
      if (code === 200) {
        commit("SET_SCHEDULES", data || []);
      }
      commit("SET_LOADING", false);
      return res;
    } catch (error) {
      commit("SET_LOADING", false);
      throw new Error(error);
    }
  },

  async createSchedule({ rootState }, scheduleData) {
    try {
      const userId = rootState.user.userId;
      const res = await createSchedule({
        userID: userId,
        ...scheduleData,
      });
      // returns only businessTaskID
      // reload data after create success
      return res;
    } catch (error) {
      throw new Error(error);
    }
  },

  async updateSchedule(_, scheduleData) {
    try {
      const res = await updateSchedule(scheduleData);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  },

  async confirmTaskStatus(_, { businessTaskID, taskStatus, notificationType }) {
    try {
      const res = await confirmTask({
        businessTaskID,
        taskStatus,
        notificationType,
      });
      return res;
    } catch (error) {
      throw new Error(error);
    }
  },
};

const getters = {
  schedules: (state) => state.schedules,
  loading: (state) => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
